import { render, staticRenderFns } from "./goPrevention.vue?vue&type=template&id=23182fc0&scoped=true&"
import script from "./goPrevention.vue?vue&type=script&lang=js&"
export * from "./goPrevention.vue?vue&type=script&lang=js&"
import style0 from "./goPrevention.vue?vue&type=style&index=0&id=23182fc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23182fc0",
  null
  
)

export default component.exports